module.exports = __webpack_public_path__ + "img/img_kv_2_thumb.be9975f3.jpg";